import React, { memo } from "react";
import styled from "styled-components";
import { bookingStore } from "../../../stores/booking.store";
import { LogoRR } from "../../footer/LogoRR";

const RRMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 18px;
  margin: 24px auto 32px;
  border-radius: 5px;
  background-color: ${(props) => props.theme.informationTextBackgroundColor};
  color: ${(props) => props.theme.textColorGray};

  @media screen and (max-width: 780px) {
    position: inherit;
  }
`;

const RRMessageTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin: 12px 0;
`;
const RRMessageText = styled.div`
  line-height: 16px;
  text-align: center;
  margin: 12px;
`;

const InsertRRMessage = () => {
  const title = bookingStore.booking.rr_data?.title;
  const text = bookingStore.booking.rr_data?.text;

  return (
    <RRMessageWrapper data-test="rr-message">
      <LogoRR />
      <RRMessageTitle
        data-test="rr-message-title"
        dangerouslySetInnerHTML={{ __html: title! }}
      />
      <RRMessageText
        data-test="rr-message-text"
        dangerouslySetInnerHTML={{ __html: text! }}
      />
    </RRMessageWrapper>
  );
};
export const RRMessage = memo(InsertRRMessage);
